import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
    selector: 'app-something-went-wrong-modal',
    templateUrl: './something-went-wrong-modal.component.html',
    styleUrls: ['./something-went-wrong-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SomethingWentWrongModalComponent {
  @Input() public visible = false;
  @Output() public modalClose = new EventEmitter<void>();

  public closeModal(): void {
    this.modalClose.emit();
  }
}
